// Wires the shared LocationDetailsV2 show/hide controller (ILJ-814/815) onto
// the employer job ad edit form (app/views/employer/job_ads/_form.html.slim).
//
// That form is server-rendered outside the `.lj-wizard-post` wizard tree, so
// it never went through PostWizard#locationDetailsV2 and its conditional
// blocks (office attendance, visa/relocation criteria, remote question tree)
// stayed permanently hidden regardless of work_model. This self-initializes
// whenever the v2 work-model markup is present, reusing the exact same
// controller the wizard uses.
import LocationDetailsV2 from './location_details_v2';

const WORK_MODEL_CONTAINER_ID = 'job-work-model-options';

const initialize = () => {
  const workModelContainer = document.getElementById(WORK_MODEL_CONTAINER_ID);
  if (!workModelContainer) return;

  // Avoid double-binding on cached Turbolinks visits.
  if (workModelContainer.dataset.locationDetailsV2Bound === 'true') return;
  workModelContainer.dataset.locationDetailsV2Bound = 'true';

  new LocationDetailsV2(WORK_MODEL_CONTAINER_ID).init();
};

document.addEventListener('turbolinks:load', initialize);
